import React from 'react';
import classNames from 'classnames';

import { DEFAULT_USER_AVATAR_URL } from '../../constants/commonConstants';

import styles from './UserAvatar.module.scss';

const bgColors = [
  'var(--background-accent-orange-subtle, #FFE8D3)',
  'var(--background-accent-green-subtle, #B7FEE1)',
  'var(--background-accent-blue-subtle, #DFEAFF)',
];

const textColors = [
  '#CA4A00', // for orange background
  '#007234', // for green background
  '#003CA6', // for blue background
];

function getInitials(name) {
  if (!name) return '';
  const words = name.trim().split(' ');
  return words[0][0].toUpperCase();
}

function getBgColorAndTextColor(initial) {
  if (!initial) return { bgColor: bgColors[0], textColor: textColors[0] };
  const index = initial.charCodeAt(0) % bgColors.length;
  return { bgColor: bgColors[index], textColor: textColors[index] };
}

export const UserAvatar = ({ imageUrl, name }) => {
  const initial = getInitials(name);
  const { bgColor, textColor } = getBgColorAndTextColor(initial);

  const isDefaultAvatar = imageUrl === DEFAULT_USER_AVATAR_URL;

  return (
    <div
      className={classNames(styles.userAvatar, { [styles.bgTransparent]: imageUrl && !isDefaultAvatar })}
      style={!imageUrl ? { background: bgColor } : {}}
    >
      {imageUrl && !isDefaultAvatar ? (
        <img src={imageUrl} alt={name} className={styles.avatarImage} />
      ) : (
        <span className={styles.avatarName} style={{ color: textColor }}>
          {initial}
        </span>
      )}
    </div>
  );
};
